/* FL Option-Order: RAL-Picker (Farbton+Glanzgrad) VOR Groesse, dann Anzahl. */
(function(){
  function reorder(){
    try{
      var info=document.querySelector('.product-info'); if(!info)return;
      var ral=info.querySelector(':scope > .ralpicker') || info.querySelector('.ralpicker');
      var vp=info.querySelector('.product-info__variant-picker');
      if(ral&&vp&&vp.parentNode){
        if(ral.nextElementSibling!==vp || ral.parentNode!==vp.parentNode){
          vp.parentNode.insertBefore(ral, vp);
        }
      }
    }catch(e){}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',reorder);else reorder();
  [150,500,1200,2500].forEach(function(d){setTimeout(reorder,d);});
  try{ var t=document.querySelector('.product-info'); if(t)new MutationObserver(function(){reorder();}).observe(t,{childList:true}); }catch(e){}
})();